export default __webpack_public_path__ + "static/media/productslide-5.eaf04e72.jpg";